import { Row, SizedBox } from "../CommonBaseComponents";
import CustomImage from "../image/CustomImage";
import { C3Text } from "../text/CustomText";
import CustomIcon from "../image/CustomIcon";
import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { FixedPositionDropdownWrapper } from "./CustomDropdownWrapper";
import { Theme } from "../../Theme";

export const Languages = [
    { value: "ko", label: "한국어", image: "image_flag_ko", flagImage: "image_flag_square_ko" },
    { value: "en", label: "English", image: "image_flag_en", flagImage: "image_flag_square_en" },
    { value: "es", label: "Español", image: "image_flag_en", flagImage: "image_flag_square_es" },
    { value: "fr", label: "Français", image: "image_flag_ko", flagImage: "image_flag_square_fr" },
    { value: "zh", label: "中文", image: "image_flag_ko", flagImage: "image_flag_square_zh" },
    { value: "ru", label: "Русский", image: "image_flag_ko", flagImage: "image_flag_square_ru" },
];

const DROPDOWN_WIDTH = 252;

export default function LanguageDropdownMenu({
    initValue,
    setValue,
    values,
    onClose,
    anchorEl, // 버튼 엘리먼트를 받음
    placement = "bottom-end", // 'bottom-start' | 'bottom-end'
}) {
    const [position, setPosition] = useState({ top: 0, left: 0 });

    useEffect(() => {
        if (anchorEl) {
            const rect = anchorEl.getBoundingClientRect();
            let leftPos;

            if (placement === "bottom-end") {
                leftPos = rect.right - DROPDOWN_WIDTH;
            } else {
                // 'bottom-start'
                leftPos = rect.left;
            }

            setPosition({
                top: rect.bottom + window.scrollY + 8, // 버튼 바로 아래 + 8px 여백
                left: leftPos + window.scrollX,
            });
        }
    }, [anchorEl, placement]);

    const applyValue = (e, value) => {
        e.stopPropagation();
        setValue(value);
        onClose();
    };

    const dropdownContent = (
        <FixedPositionDropdownWrapper
            $top={position.top}
            $left={position.left}
            $width={DROPDOWN_WIDTH}
            data-is-dropdown="true"
        >
            {values.map((v) => (
                <SizedBox
                    width={"252px"}
                    height={"auto"}
                    hoverBackgroundColor={Theme.color.zinc150}
                    padding={"0 10px"}
                    borderRadius={"4px"}
                    onClick={(e) => applyValue(e, v.value)}
                    cursor={"pointer"}
                >
                    <Row width={"100%"} justifyContent={"space-between"} padding={"10px 10px"} cursor={"pointer"}>
                        <Row key={v.value} justifyContent={"flex-start"} cursor={"pointer"}>
                            <CustomImage
                                imageName={v.flagImage}
                                width={"22px"}
                                height={"16.5px"}
                                marginRight={"10px"}
                            />
                            <SizedBox width={"8px"} />
                            <C3Text fontColor={Theme.color.zinc850}>{v.label}</C3Text>
                        </Row>
                        {initValue === v.value && <CustomIcon iconName={"checked_black"} size={"22px"} />}
                    </Row>
                </SizedBox>
            ))}
        </FixedPositionDropdownWrapper>
    );

    return createPortal(dropdownContent, document.body);
}
